// ----
// JS for Captcha Widgets
// ----

var SCM = SCM || {};

SCM.Captcha = (function () {

    var _simpleCaptchaResponseIdentifier = '#txtCaptchaInputId';
    var _googleReCaptchaResponseIdentifier = '.g-recaptcha-response';
    const _simpleCaptchaFallbackUrl = '/ThirdParty/ReCaptcha/Captcha_FallBackToSimpleCaptcha';
    var _defaultTokenLifetimeMs = 60000; // Google doesn't document/guarantee an exact token lifetime; verified empirically at 60s. Overridden by data-token-lifetime-seconds.
    var _expiryWarningTimer = null;

    $(document).on('click', '.js-captcha-refresh-button', _handleRefreshButtonClick);

    return {
        Init : init,
        GetCaptchaResponse : getCaptchaResponse,
		GetCaptchaInfo : getCaptchaInfo,
        ResetCaptcha : resetCaptcha
    };

    // initializes the gRecaptcha v2 js
    // returns true if init succeeds, false otherwise (helps with debugging)
    function init(captchaModelSiteKey, onReCaptchaRendered) {
        if (window.grecaptcha === undefined || window.grecaptcha === null) {
            return false;
        }

        if (_originIsRewrittenByAProxy()) {
            _fallBackToSimpleCaptcha().then(function (replaced) {
                if (!replaced) {
                    _renderReCaptcha(captchaModelSiteKey, onReCaptchaRendered);
                }
            }).catch(function (reason) {
                console.error(reason);
                _renderReCaptcha(captchaModelSiteKey, onReCaptchaRendered);
            });

            return true;
        }

        _renderReCaptcha(captchaModelSiteKey, onReCaptchaRendered);

        return true;
    }

    function _renderReCaptcha(captchaModelSiteKey, onReCaptchaRendered) {
        if (!$('#captcha').length) {
            return;
        }

        const widgetId = window.grecaptcha.render('captcha', {
            'sitekey': captchaModelSiteKey,
            'error-callback': _handleRecaptchaRenderingError,
            'callback': _handleRecaptchaSolved,
            'expired-callback': _handleRecaptchaExpired
        });

        if (onReCaptchaRendered) {
            onReCaptchaRendered(widgetId);
        }
    }

    // Google validates the site key against the address-bar origin, which a URL-rewriting proxy changes while forwarding the canonical Host, so only the browser can see the mismatch; the hostname travels base64-encoded so the proxy's HTML rewriter cannot rewrite it into a false match.
    function _originIsRewrittenByAProxy() {
        const encodedServedHostName = $('#captcha').data('encodedServedHostname');
        if (!encodedServedHostName) {
            return false;
        }

        try {
            return window.location.hostname.toLowerCase() !== atob(encodedServedHostName).toLowerCase();
        } catch (reason) {
            console.error(reason);
            return false;
        }
    }

    // WCAG 2.2.1: the token issued here expires some fixed time after the widget is solved
    // (Google-controlled, not configurable by us). Warn the user before that happens and let
    // them refresh (re-verify) without limit.
    function _handleRecaptchaSolved() {
        _clearExpiryWarningTimer();
        _hideExpiryMessages();

        var $captcha = $('#captcha');
        var $wrap = $captcha.closest('.js-recaptcha-wrap');

        var tokenLifetimeSeconds = parseInt($captcha.data('tokenLifetimeSeconds'), 10);
        var tokenLifetimeMs = isNaN(tokenLifetimeSeconds) ? _defaultTokenLifetimeMs : (tokenLifetimeSeconds * 1000);

        var warningLeadSeconds = parseInt($captcha.data('expiryWarningLeadSeconds'), 10);
        if (isNaN(warningLeadSeconds)) {
            warningLeadSeconds = 0;
        }

        var warningDelayMs = tokenLifetimeMs - (warningLeadSeconds * 1000);
        if (warningDelayMs > 0) {
            _expiryWarningTimer = setTimeout(function () {
                $wrap.find('.js-captcha-expiry-warning').removeClass('hide');
            }, warningDelayMs);
        }
    }

    function _handleRecaptchaExpired() {
        _clearExpiryWarningTimer();
        var $wrap = $('#captcha').closest('.js-recaptcha-wrap');
        $wrap.find('.js-captcha-expiry-warning').addClass('hide');
        $wrap.find('.js-captcha-expired-message').removeClass('hide');
    }

    function _handleRefreshButtonClick() {
        var $wrap = $(this).closest('.js-recaptcha-wrap');
        _clearExpiryWarningTimer();
        _hideExpiryMessages($wrap);
        window.grecaptcha.reset();
    }

    function _hideExpiryMessages($wrap) {
        $wrap = $wrap || $('#captcha').closest('.js-recaptcha-wrap');
        $wrap.find('.js-captcha-expiry-warning, .js-captcha-expired-message').addClass('hide');
    }

    function _clearExpiryWarningTimer() {
        if (_expiryWarningTimer !== null) {
            clearTimeout(_expiryWarningTimer);
            _expiryWarningTimer = null;
        }
    }

    function _fallBackToSimpleCaptcha() {
        return SCM.Ajax.get(_simpleCaptchaFallbackUrl)
            .expectHtml()
            .then(function (simpleCaptchaMarkup) {
                const $widget = $('#captcha').closest('.widget-ReCaptcha');
                if (!simpleCaptchaMarkup || !simpleCaptchaMarkup.length || !$widget.length) {
                    return false;
                }

                $widget.replaceWith(simpleCaptchaMarkup);
                return true;
            });
    }

    function _handleRecaptchaRenderingError() {
        _fallBackToSimpleCaptcha().catch(console.error);
    }


    // returns the detected captcha response, empty string otherwise
    function getCaptchaResponse($formContainer) {
        
        var element = $formContainer.find(_simpleCaptchaResponseIdentifier);

        if (element.is(':visible')) {
            return element.val();
        }
        
        element = $formContainer.find(_googleReCaptchaResponseIdentifier);

        if (element.length) {
            return element.val();
        }

        return '';
    }
	
	//returns more detailed captcha information, needed for some custom behaviors
	function getCaptchaInfo() {
		
		var useV3 = $('#recaptchaUseV3').val();
		var captchaToken = getCaptchaToken(_googleReCaptchaResponseIdentifier);
		
		return {
            ReCaptchaV3Token: (useV3 === 'True') ? captchaToken : '',
            ReCaptchaV2Token: (useV3 === 'False') ? captchaToken : '',
            SimpleCaptchaToken: getCaptchaToken(_simpleCaptchaResponseIdentifier),
            ReCaptchaWidgetControlId: getCaptchaToken('#recaptchaWidgetInstance'),
            UserEmail: $('.js-captchaUserEmail').val()
        };
	}
	
	function getCaptchaToken(tokenSelector) {
        var token = $(tokenSelector).val();
        if (typeof token === 'undefined' || token.length == 0) {
            return '';
        }
        return token;
    }
    
    // resets the google captcha (if it exists)
    function resetCaptcha($formContainer) {
        var element = $formContainer.find(_googleReCaptchaResponseIdentifier);

        if (element.length) {
            // grecaptcha is loaded by ajax response from third party
            // see ReCaptcha.cshtml
            _clearExpiryWarningTimer();
            _hideExpiryMessages($formContainer.find('.js-recaptcha-wrap'));
            window.grecaptcha.reset();
        }
    }

})();